module.exports = __webpack_public_path__ + "static/media/trofeo4.536d637d.png";